// extracted by css-extract-rspack-plugin
export default {"deviceList":"device-list-module__deviceList___tehl3","divider":"device-list-module__divider___YR4su"};